import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/stock-counts', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/stock-counts/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/stock-counts', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/stock-counts/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/v1/stock-counts/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const product = () => {
    return httpClient
    .get('/api/v1/stock-counts/products')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data)) 
}

export const user = () => {
  return httpClient
  .get('/api/v1/stock-counts/users')
  .then(response => Promise.resolve(response.data))
  .catch(error => Promise.reject(error.response.data)) 
}

export const generate = data => {
  return httpClient
    .post('/api/v1/stock-counts/generates', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { 
    get, 
    find,
    store,
    update,
    destroy,
    product,
    user,
    generate
}
